import React from "react";
import "./Attendance.css";
import AttendanceComp from "../../../commons/Employees/Attendance/AttendanceComp";

const Attendance = () => {
  return (
    <>
      <div className="Attendance">
        <AttendanceComp />
      </div>
    </>
  );
};

export default Attendance;
